import ariaLogo from "@/assets/aria-logo.png";

export const AriaMark = ({ size = 16, className = "" }) => (
  <img src={ariaLogo} alt="Aria" data-testid="aria-mark"
    style={{ width: size, height: size, borderRadius: Math.round(size * 0.28) }}
    className={`shrink-0 object-contain ${className}`} />
);
